import React from "react";
import PNF from "../Images/PNF.jpg";

const NotFound = () => {
  return (
    <div>
      <img
        className="mt-2"
        style={{ height: 450, width: 1250 }}
        src={PNF}
        alt=""
      />
    </div>
  );
};

export default NotFound;
